import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminLabRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/labs/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/admin/Labs/AdminLabPage/AdminLabPage').then((d) => d.Route));
